import { render, staticRenderFns } from "./EmailInsights.vue?vue&type=template&id=5d807429&scoped=true"
import script from "./EmailInsights.vue?vue&type=script&lang=js"
export * from "./EmailInsights.vue?vue&type=script&lang=js"
import style0 from "./EmailInsights.vue?vue&type=style&index=0&id=5d807429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d807429",
  null
  
)

export default component.exports